export default __webpack_public_path__ + "static/media/suva-red_arrow.6d412dd1.png";